// import { toast } from "react-hot-toast";
import ActionCreator from "../../utils/helpers/actionCreator";
import { RemittanceService } from "../../utils/services/remittance.service";
import * as RemittanceConstants from "../constants/remittance.constant";
import { expiredTokenCheck } from "./auth.action";

export const getRemittances =
  (page, chargeCategory, size) => async (dispatch) => {
    try {
      dispatch(ActionCreator(RemittanceConstants.GET_REMITTANCE_REQUEST));

      const { data: responseData } = await RemittanceService.fetchRemittances(
        page,
        chargeCategory,
        size
      );

      // if (responseData.status === "FAILED") throw responseData;

      dispatch(
        ActionCreator(RemittanceConstants.GET_REMITTANCE_SUCCESS, responseData)
      );

      // toast.success("Fees fetched successfully.");
    } catch (error) {
      expiredTokenCheck(error, dispatch);

      dispatch(ActionCreator(RemittanceConstants.GET_REMITTANCE_FAILURE));
    }
  };

export const getRemittanceSettingsValue = () => async (dispatch) => {
  try {
    dispatch(
      ActionCreator(RemittanceConstants.GET_REMITTANCE_SETTINGS_VALUES_REQUEST)
    );

    const { data: responseData } =
      await RemittanceService.fetchRemittancesFeeSettings();

    if (responseData.status === "FAILED") throw responseData;

    dispatch(
      ActionCreator(
        RemittanceConstants.GET_REMITTANCE_SETTINGS_VALUES_SUCCESS,
        responseData
      )
    );

    // toast.success("Remittance settings value fetched successfully.");
  } catch (error) {
    expiredTokenCheck(error, dispatch);

    dispatch(
      ActionCreator(RemittanceConstants.GET_REMITTANCE_SETTINGS_VALUES_FAILURE)
    );
  }
};

export const getPasswordPolicyValue = () => async (dispatch) => {
  try {
    dispatch(ActionCreator(RemittanceConstants.VIEW_PASSWORD_POLICY_REQUEST));

    const { data: responseData } = await RemittanceService.viewPasswordPolicy();

    if (responseData.status === "FAILED") throw responseData;

    dispatch(
      ActionCreator(
        RemittanceConstants.VIEW_PASSWORD_POLICY_SUCCESS,
        responseData
      )
    );

    // toast.success("password policy values fetched successfully.");
  } catch (error) {
    expiredTokenCheck(error, dispatch);

    dispatch(ActionCreator(RemittanceConstants.VIEW_PASSWORD_POLICY_FAILURE));
  }
};

export const getPaymentMethodFees = () => async (dispatch) => {
  try {
    dispatch(ActionCreator(RemittanceConstants.GET_PAYMENT_METHOD_REQUEST));

    const { data: responseData } =
      await RemittanceService.listDefaultChargeForPaymentMethod();

    if (responseData.status === "FAILED") throw responseData;

    dispatch(
      ActionCreator(
        RemittanceConstants.GET_PAYMENT_METHOD_SUCCESS,
        responseData
      )
    );

    // toast.success("fees fetched successfully.");
  } catch (error) {
    expiredTokenCheck(error, dispatch);

    dispatch(ActionCreator(RemittanceConstants.GET_PAYMENT_METHOD_FAILURE));
  }
};

export const getFixedAmountFees = (deliveryMethod) => async (dispatch) => {
  try {
    dispatch(ActionCreator(RemittanceConstants.GET_FIXED_AMOUNT_FEE_REQUEST));

    const { data: responseData } =
      await RemittanceService.listDefaultChargeForFixedAmountFee(
        deliveryMethod
      );

    if (responseData.status === "FAILED") throw responseData;

    dispatch(
      ActionCreator(
        RemittanceConstants.GET_FIXED_AMOUNT_FEE_SUCCESS,
        responseData
      )
    );

    // toast.success("fees fetched successfully.");
  } catch (error) {
    expiredTokenCheck(error, dispatch);

    dispatch(ActionCreator(RemittanceConstants.GET_FIXED_AMOUNT_FEE_FAILURE));
  }
};
